import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { tabsAnatomy } from '@chakra-ui/anatomy';

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(tabsAnatomy.keys);

const myVariant = definePartsStyle({
  tab: {
    _selected: {
      bgColor: 'bloodMoon.40',
      borderColor: 'bloodMoon.100',
      color: 'white.100',
      opacity: 1,
      borderTopRadius: '4px',
      _hover: {
        bgColor: 'bloodMoon.40',
      },
    },
    _hover: {
      bgColor: 'white.30',
      color: 'white.100',
      opacity: 1,
    },
    bgColor: 'white.10',
    color: 'white.80',
    border: '1px solid',
    borderColor: 'white.60',
    opacity: 0.6,
    fontWeight: 600,
    h: 9,
    w: '100%',
    textTransform: 'uppercase',
    borderTopRadius: '8px',
  },

  tablist: {
    gap: 3,
  },

  tabpanels: {
    mt: 4,
  },

  tabpanel: {
    padding: 0,
  },
});

const myVariant2 = definePartsStyle({
  tab: {
    _selected: {
      bgColor: 'white.20',
      borderColor: 'white.40',
      color: 'white.100',
      opacity: 1,
      borderTopRadius: '8px',
      _hover: {
        bgColor: 'white.20',
      },
    },
    _hover: {
      bgColor: 'white.30',
      color: 'white.100',
      opacity: 1,
    },
    bgColor: 'white.10',
    color: 'white.80',
    border: '1px solid',
    borderColor: 'white.60',
    opacity: 0.6,
    fontWeight: 600,
    h: 9,
    w: '100%',
    textTransform: 'uppercase',
    borderTopRadius: '8px',
  },

  tablist: {
    gap: 1,
  },

  tabpanels: {
    mt: 4,
  },

  tabpanel: {
    padding: 0,
  },
});

const tabWallet = definePartsStyle({
  tab: {
    w: 'full',
    textTransform: 'uppercase',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '14px',
    _selected: {
      background: 'bloodMoon.100',
      borderTopRadius: '20px',
    },
  },
  tablist: {
    background: 'linear-gradient(180deg, #1E1E1E 0%, #121212 100%)',
    borderTopRadius: '20px',
    p: 0,
    h: 49,
  },
  tabpanel: {
    padding: 0,
  },
});

const tabRaces = definePartsStyle({
  tab: {
    bg: 'linear-gradient(360deg, rgba(165, 165, 165, 0.1) 0%, rgba(165, 165, 165, 0.04) 100%)',
    borderBottom: '2px solid',
    borderColor: 'rgba(255, 255, 255, 0.18)',
    opacity: 0.9,
    fontWeight: 600,
    color: 'white.40',
    textTransform: 'uppercase',
    _hover: {
      bg: 'linear-gradient(360deg, rgba(165, 165, 165, 0.2) 0%, rgba(165, 165, 165, 0.08) 100%)',
      borderBottom: '2px solid',
      borderColor: 'rgba(255, 255, 255, 0.3)',
      color: 'white.80',
      opacity: 1,
    },
    _selected: {
      bg: 'linear-gradient(360deg, rgba(79, 197, 186, 0.4) 0%, rgba(79, 197, 186, 0.16) 100%)',
      borderBottom: '2px solid',
      borderColor: 'rgba(79, 197, 186, 1)',
      color: 'treasuredTeal.100',
      opacity: 1,
    },
  },
  tablist: {
    gap: { base: 1, md: 2 },
  },
});

const subTabRaces = definePartsStyle({
  tab: {
    border: '2px solid rgba(255, 255, 255, 0.08)',
    borderRadius: '4px',
    p: { base: 2, md: 4 },
    opacity: 0.8,
    color: 'white.80',
    _hover: {
      borderColor: 'rgba(255, 255, 255, 0.24)',
      opacity: 1,
    },
    _selected: {
      background:
        'linear-gradient(225deg, #FFFFFF 0%, #EEEEEE 18%, #A0A0A0 73%, #979797 100%)',
      color: 'black.80',
      border: 'none',
      opacity: 1,
    },
    '&[data-custom="my-car"]': {
      background:
        'linear-gradient(225deg, #6DF1E5 0%, #4FC5BA 18%, #26A69A 73%, #1A746B 100%)',
      backgroundClip: 'text',
      border: '2px solid',
      borderColor: 'rgba(76, 194, 183, 0.2)',
      _hover: {
        opacity: 0.9,
        borderColor: 'rgba(76, 194, 183, 0.6)',
      },
      _selected: {
        background:
          'linear-gradient(225deg, #6DF1E5 0%, #4FC5BA 18%, #26A69A 73%, #1A746B 100%)',
        color: 'black.80',
        border: 'none',
      },
    },
  },
  tablist: {
    gap: { base: 1, md: 2 },
  },
});

const subTabTournaments = definePartsStyle({
  tab: {
    border: '2px solid rgba(255, 255, 255, 0.08)',
    borderRadius: '4px',
    color: 'white.80',
    background:
      'linear-gradient(225deg, #FFFFFF 0%, #EEEEEE 18%, #A0A0A0 73%, #979797 100%)',
    backgroundClip: 'text',
    _hover: {
      background:
        'linear-gradient(225deg, #FFFFFF 0%, #EEEEEE 18%, #A0A0A0 73%, #979797 100%)',
      backgroundClip: 'text',
      borderColor: 'rgba(255, 255, 255, 0.2)',
    },
    _selected: {
      color: 'black.80',
      background:
        'linear-gradient(225deg, #FFFFFF 0%, #EEEEEE 18%, #A0A0A0 73%, #979797 100%)',
      backgroundOrigin: 'border-box',
    },
    '&[data-custom="weekly-calendar"]': {
      background: 'rgba(239, 200, 98, 1)',
      backgroundClip: 'text',
      _selected: {
        background:
          'linear-gradient(225deg, #FCF4BF 0%, #EFC862 18%, #CD9832 73%, #BB811B 100%)',
        color: 'black.80',
        backgroundOrigin: 'border-box',
      },
    },
  },
  tablist: {
    gap: 1,
  },
});

export const tabTheme = defineMultiStyleConfig({
  variants: {
    myVariant,
    myVariant2,
    tabWallet,
    tabRaces,
    subTabRaces,
    subTabTournaments,
  },
  defaultProps: {
    variant: 'myVariant',
  },
});
